const connectionsNameMapper: { [key: string]: string } = {
	'google-oauth2': 'Google',
	'facebook-oauth2': 'Facebook',
	'linkedin-oauth2': 'LinkedIn',
	'apple-oauth2': 'Apple',
};

export { connectionsNameMapper };
